import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { DeviceController } from '@models/device/device-controller';
import { EndpointParams } from '@models/http/endpoint-params';
import { OpenAccessControl } from '@models/device/open-access-control';
import { HttpService } from '../http/http.service';

@Injectable({ providedIn: 'root' })
export class DeviceService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'security', version: 1 };
    private readonly dataStore: { devices: DeviceController[] }
        = { devices: [] };
    private readonly loadingSubject$ = new BehaviorSubject<boolean>(true);
    private readonly devicesSubject$ = new BehaviorSubject<DeviceController[]>([]);

    devices = this.devicesSubject$.asObservable();
    isLoadingData = this.loadingSubject$.asObservable();

    getData(): void {
        this.devicesList().subscribe({ next: () => {
            this.next(Object.assign({}, this.dataStore).devices);
        }});
    }

    manualAccess(openAccessControl: OpenAccessControl): Observable<any> {
        return this.post('device/commands/access', this.defaultEndpointParams, openAccessControl, this.noShowErrorNotification);
    }

    private devicesList(): Observable<any> {
        const url = 'devices';
        this.loading(true);

        return this.get(url, this.defaultEndpointParams).pipe(tap((data: any[]) => {
            const devices: DeviceController[] = [];
            data.forEach(device => {
                devices.push(device);
            });
            this.dataStore.devices = [...devices];
            this.loading(false);
        }, () => {
            this.loading(false);
        }));
    }

    private next(data: DeviceController[]): void {
        this.devicesSubject$.next(data);
    }

    private loading(value: boolean): void {
        this.loadingSubject$.next(value);
    }
}
